import { useMemo } from 'react';

const SPRITES = ['leaf-russet', 'leaf-gold', 'leaf-ochre'] as const;
const PATH_COUNT = 5;

export function LeafBurst() {
  const leaves = useMemo(
    () =>
      Array.from({ length: PATH_COUNT }, (_, i) => ({
        sprite: SPRITES[Math.floor(Math.random() * SPRITES.length)],
        path: i + 1,
      })),
    [],
  );

  return (
    <span className="leaf-burst" aria-hidden>
      {leaves.map((leaf, i) => (
        <img
          key={i}
          className={`leaf-burst__leaf leaf-drift-${leaf.path}`}
          src={`/leaves/${leaf.sprite}.png`}
          alt=""
        />
      ))}
    </span>
  );
}
